import { render, staticRenderFns } from "./WelcomeDia.vue?vue&type=template&id=6c9a9a98&"
import script from "./WelcomeDia.vue?vue&type=script&lang=js&"
export * from "./WelcomeDia.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeDia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c9a9a98')) {
      api.createRecord('6c9a9a98', component.options)
    } else {
      api.reload('6c9a9a98', component.options)
    }
    module.hot.accept("./WelcomeDia.vue?vue&type=template&id=6c9a9a98&", function () {
      api.rerender('6c9a9a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/createCode/WelcomeDia.vue"
export default component.exports